<template>
    <div class="content-window-container"
         v-observe-visibility="visibilityChanged"
         :id="pageID">
        <div class="container pc-road-map">
            <div class="panel top clear">
                <div v-for="(p, qIdx) in $t('Page.RoadMap.Content')"
                     :key="qIdx"
                     v-if="(0 === (qIdx + 1) % 2)"
                     class="cell">
                    <div class="indicator">
                        <div class="point"></div>
                        <div class="tail"></div>
                    </div>
                    <div class="text will-animate" data-ani="animated fadeInDown">
                        <div class="content"
                             v-for="(i, iIdx) in p.Item"
                             :key="iIdx"
                             v-html="i"></div>
                        <div class="title" v-html="p.Title"></div>
                    </div>
                </div>
            </div>
            <div class="middle-line"></div>
            <div class="panel bottom clear">
                <div v-for="(p, qIdx) in $t('Page.RoadMap.Content')"
                     :key="qIdx"
                     v-if="(1 === (qIdx + 1) % 2)"
                     class="cell">
                    <div class="indicator">
                        <div class="point"></div>
                        <div class="tail"></div>
                    </div>
                    <div class="text will-animate" data-ani="animated fadeInUp">
                        <div class="title" v-html="p.Title"></div>
                        <div class="content"
                             v-for="(i, iIdx) in p.Item"
                             :key="iIdx"
                             v-html="i"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container mobile-road-map swiper-container">
            <div class="window-title will-animate"  data-ani="animated fadeInDown">{{$t('Page.RoadMap.Title')}}</div>
            <div class="middle-line"><div></div></div>
            <div v-for="(p, qIdx) in $t('Page.RoadMap.Content')"
                 :key="qIdx"
                 class="mobile-road-map-cell clear" data-ani="animated fadeInLeft">
                <div class="title-container will-animate" :data-ani="((qIdx + 1) % 2 === 0) ? 'animated fadeInLeft':'animated fadeInRight'">
                    <div class="title" :class="roadMapStatus(qIdx)">
                        <span>{{p.Title.split(' ')[0]}}</span>
                        <span>{{p.Title.split(' ')[1]}}</span>
                    </div>
                </div>

                <div class="content-container will-animate" :data-ani="((qIdx + 1) % 2 === 1) ? 'animated fadeInLeft':'animated fadeInRight'">
                    <div class="content">
                        <div class="item"
                             v-for="(i, iIdx) in p.Item"
                             :key="iIdx"
                             v-html="i"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import {pageMounted, mustSlideCommonContent, basicPageMethods} from "../js/common"
  import {scNamespace} from "../js/scNamespace"

  export default {
    name: "roadmap",
    mounted: pageMounted,
    methods: {
      ...basicPageMethods(),
      localMounted() {
      },
      roadMapStatus(roadMapIdx) {
        if(1 === roadMapIdx) {
          return 'progress'
        } else {
          if(1 > roadMapIdx) {
            return 'complete'
          }
        }

        return ''
      }
    },
    data() {
      return {
        pageID: scNamespace.PAGE.ROAD_MAP.id
      }
    }
  }
</script>

<style scoped>
    .pc-road-map {
        display: block;
    }
    .mobile-road-map {
        display: none;
    }
    div {
        position: relative;
    }
    .panel {
        z-index: 10000;
    }
    .panel.top {
        margin-top: 60px;
    }

    .panel.top .cell:first-child{
        margin-left: 15%;
    }

    .panel.bottom .cell:first-child{
        margin-left: 5%;
    }
    .middle-line {
        position: relative;
        width: 100%;
        height: 1px;
        background-color: #ba2713;
    }

    .panel .cell {
        width: 20%;
        float: left;
        height: 200px;
        padding: 20px 40px;
    }

    .panel .cell .text {
        text-align: center;
    }

    .panel.top .cell .text {
        position: absolute;
        width: 100%;
        left: 0;
        bottom: 44px;
    }

    .panel.bottom .cell .text {
        margin-top: 38px;
    }

    .panel .cell .text .title {
        font-weight: 500;
        font-size: 18px;
        padding: 20px 0;
    }

    .panel.bottom .cell .text .title {
        margin-bottom: 10px;
    }
    .panel .cell .text .content {
        position: relative;
        font-size: 14px;
        line-height: 16px;
        margin-bottom: 12px;
    }

    .panel .cell .text .content::before {
        content: '';
        display: inline-block;
        width: 4px;
        height: 4px;
        border-radius: 50%;
        margin-right: 4px;
        background-color: #000000;
        transform: translateY(-4px);
    }

    .cell .indicator {
        position: absolute;
        width: 24px;
        left: 50%;
        margin-left: -12px;
        top: -12px;
    }

    .panel.top .cell .indicator {
        top: auto;
        bottom: -12px;
    }

    .cell .indicator .point {
        position: relative;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        border: 2px solid #ba2713;
        background-color: #ffffff;
    }

    .cell .indicator .point::after {
        content: ' ';
        position: absolute;
        display: block;
        left: 50%;
        top: 50%;
        width: 8px;
        height: 8px;
        margin-left: -4px;
        margin-top: -4px;
        border-radius: 50%;
        background-color: #ba2713;
    }

    .cell .indicator .tail {
        position: absolute;
        width: 2px;
        height: 40px;
        left: 50%;
        margin-left: -1px;
        background-color: #ba2713;
    }

    .cell .indicator .tail::after {
        content: ' ';
        position: absolute;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        left: -3px;
        top: 40px;
        background-color: #ba2713;
    }

    .panel.top .cell .indicator .tail {
        margin-top: -64px;
    }

    .panel.top .cell .indicator .tail::after {
        top: -2px;
    }
</style>

<style scoped>
    @media screen and (max-width: 720px){
        .pc-road-map {
            display: none;
        }

        .window-title {
            margin-bottom: 60px !important;
        }

        .mobile-road-map {
            display: block;
            text-align: center;
        }

        .mobile-road-map .title {
            font-size: 22px;
            margin-bottom: 30px;
        }

        .mobile-road-map > .middle-line {
            position: absolute;
            left: 50%;
            top: 0;
            width: 1px;
            height: 100%;
            padding-top: 100px;
            padding-bottom: 40px;
            background-color: transparent;
        }

        .mobile-road-map > .middle-line > div {
            width: 1px;
            height: 100%;
            background-color: #ba2713;
        }

        .mobile-road-map-cell {
            width: 100% !important;
            padding: 40px 0;
            min-height: 200px;
        }

        .mobile-road-map-cell > div {
            float: left;
            width: 50%;
        }

        .mobile-road-map-cell > div.title-container > div.title {
            width: 120px;
            height: 120px;
            margin: 0 auto;
            padding-top: 50px;
            border-radius: 50%;
            text-align: center;
            border: 1px solid #ba2713;
            float: left;
        }

        .mobile-road-map-cell > div.title-container > div.title.complete {
            background-color: #ba2713;
            color: #fff;
        }

        .mobile-road-map-cell > div.title-container > div.title.progress {
            border: 6px solid #ba2713;
            padding-top: 46px;
        }

        .mobile-road-map-cell:nth-child(even) > div.title-container > div.title {
            float: right;
        }

        .mobile-road-map-cell:nth-child(even) > div.title-container {
            float: right;
        }

        .mobile-road-map-cell > div.title-container > div.title > span:first-child {
            padding-right: 6px;
        }

        .mobile-road-map-cell > div.title-container > div.title::after {
            content: ' ';
            position: absolute;
            top: 50%;
            transform: translate(0, -50%);
            height: 1px;
            width: 100px;
            right: -100px;
            background-color: #ba2713;
        }

        .mobile-road-map-cell:nth-child(even) > div.title-container > div.title::after {
            left: -100px;
            right: auto;
        }

        .mobile-road-map-cell > div.content-container{
            position: absolute;
            left: auto;
            right: 0;
            height: 100%;
            top: 0;
        }

        .mobile-road-map-cell:nth-child(even) > div.content-container {
            right: auto;
            left: 0;
            height: 100%;

        }

        .mobile-road-map-cell > div.content-container > div.content {
            padding: 10px;
            position: absolute;
            top: 50%;
            transform: translate(0, -50%);
            border-right: 0;
            border-left: 1px solid #ba2713;
            width: 100%;
            left: auto;
            right: -10px;
            background-color: #f0f4f7;

        }

        .mobile-road-map-cell:nth-child(even) > div.content-container > div.content {
            border-right: 1px solid #ba2713;
            border-left: 0;
            right: auto;
            left: -10px;
        }

        .mobile-road-map-cell > div.content-container > div.content > div.item {
            margin-bottom: 10px;
            font-size: 12px;
            line-height: 14px;
            text-align: left;
        }

        .mobile-road-map-cell > div.content-container > div.content > div.item:last-child {
            margin-bottom: 0;
        }

        .mobile-road-map-cell:nth-child(even) > div.content-container > div.content > div.item {
            text-align: right;
        }
    }
</style>

<style scoped>
    .ani-progress{
        -webkit-animation: border-color-change 4s infinite;
        -moz-animation: border-color-change 4s infinite;
        -ms-animation: border-color-change 4s infinite;
        animation: border-color-change 4s infinite;
    }

    @keyframes border-color-change {
        0% {
            border-color: #ba2713;
        }

        50% {
            border-color: #ba2713;

        }

        100% {
            border-color: #ba2713;
        }
    }
</style>